// Vendor libs
import React, {useContext, useState} from 'react';

// Material UI
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

// Images
import logo from '../assets/logo.svg';

// Dish Tech React
import {Logout} from '@dishtech-react/core';
import {RouteContext} from '../contexts/route-context';


interface ILayoutProps {
  children: React.ReactNode;
}

const useStyles = makeStyles(theme => ({
  container: {
    flexGrow: 1,
    display:'flex',
    alignItems: 'center',
  },

}));

export default ({ children }: ILayoutProps) => {
  const classes = useStyles();
    const routeContext = useContext(RouteContext);
    const [isLogoutOpen, setLogoutOpen] = useState(false);

    return (
    <div className="app">
      <AppBar color="primary">
        <Toolbar>
          <Typography component={'span'} className={classes.container}>
            <img width={75} src={logo} alt="Dish Network" />
            <div style={{marginLeft: 20}}>Out of Flash Image Management</div>
          </Typography>
          <Logout
              isLogoutOpen={isLogoutOpen}
              routeContext={routeContext}
              setLogoutOpen={setLogoutOpen}
              showIcon={true}
              textCaseUpper={false}
          />
        </Toolbar>
      </AppBar>
      <main>
        {children}
      </main>
    </div>
  );
};
